document.addEventListener('DOMContentLoaded', function() {

  /* Remove hardcoded width=1200 attribute from product images on mobile */
  if (window.innerWidth <= 860) {
    document.querySelectorAll('.pdp-gallery img, .pdp-main-img img, #pdp-main-img').forEach(function(img) {
      img.removeAttribute('width');
      img.removeAttribute('height');
      img.style.width = '100%';
      img.style.maxWidth = '100%';
      img.style.height = 'auto';
    });
  }

  /* Mobile nav */
  var hamburger = document.querySelector('.hamburger');
  var mobileNav = document.querySelector('.mobile-nav');
  if (hamburger && mobileNav) {
    hamburger.addEventListener('click', function() {
      mobileNav.classList.toggle('open');
      this.setAttribute('aria-expanded', mobileNav.classList.contains('open'));
    });
    document.addEventListener('click', function(e) {
      if (!hamburger.contains(e.target) && !mobileNav.contains(e.target)) {
        mobileNav.classList.remove('open');
        hamburger.setAttribute('aria-expanded', 'false');
      }
    });
  }

  /* Product image gallery */
  var mainImg   = document.getElementById('pdp-main-img') || document.querySelector('.pdp-main-img img');
  var mainFrame = document.querySelector('.pdp-main-img');
  var thumbs    = document.querySelectorAll('.pdp-thumb');
  var isMobile  = window.innerWidth <= 600;

  function swapImage(thumb) {
    var newSrc = thumb.getAttribute('data-src');
    if (!newSrc) {
      var ti = thumb.querySelector('img');
      if (ti) newSrc = (ti.getAttribute('src') || ti.src).replace(/_(\d+)x(\d+)/, '_1200x1200');
    }
    if (!newSrc || !mainImg) return;
    mainImg.style.opacity = '0.4';
    var ni = new Image();
    ni.onload = function() { mainImg.src = newSrc; mainImg.style.opacity = '1'; };
    ni.onerror = function() { mainImg.src = newSrc; mainImg.style.opacity = '1'; };
    ni.src = newSrc;
    setTimeout(function() { mainImg.style.opacity = '1'; }, 400);
    thumbs.forEach(function(t) { t.classList.remove('active'); });
    thumb.classList.add('active');
  }

  thumbs.forEach(function(thumb) {
    thumb.addEventListener('click', function(e) { e.preventDefault(); swapImage(this); });
    if (!isMobile) thumb.addEventListener('mouseenter', function() { swapImage(this); });
  });

  /* Image zoom — desktop only */
  if (mainFrame && mainImg && !isMobile) {
    mainFrame.style.overflow = 'hidden';
    mainFrame.style.cursor = 'zoom-in';
    mainImg.style.transition = 'transform 0.4s ease, opacity 0.12s';
    mainFrame.addEventListener('mouseenter', function() { mainImg.style.transform = 'scale(1.07)'; });
    mainFrame.addEventListener('mouseleave', function() { mainImg.style.transform = 'scale(1)'; });
    mainFrame.addEventListener('click', function() { if (mainImg.src) window.open(mainImg.src, '_blank'); });
  }

  /* Quantity */
  var qtyMinus = document.querySelector('.qty-minus');
  var qtyPlus  = document.querySelector('.qty-plus');
  var qtyVal   = document.querySelector('.qty-val');
  if (qtyMinus && qtyPlus && qtyVal) {
    qtyMinus.addEventListener('click', function() { var v = parseInt(qtyVal.textContent); if (v > 1) qtyVal.textContent = v - 1; });
    qtyPlus.addEventListener('click', function() { qtyVal.textContent = parseInt(qtyVal.textContent) + 1; });
  }

  /* ATC feedback */
  var atcBtn = document.querySelector('.atc-btn');
  if (atcBtn) {
    atcBtn.dataset.orig = atcBtn.innerHTML;
    atcBtn.closest('form') && atcBtn.closest('form').addEventListener('submit', function() {
      atcBtn.innerHTML = '&#10003; Added!';
      atcBtn.style.background = 'var(--green)';
      setTimeout(function() { atcBtn.innerHTML = atcBtn.dataset.orig; atcBtn.style.background = ''; }, 2000);
    });
  }

  /* Buy Now */
  var buyBtn = document.getElementById('buy-now-btn');
  if (buyBtn) {
    buyBtn.addEventListener('click', function() {
      var vid = document.querySelector('[name="id"]') ? document.querySelector('[name="id"]').value : '';
      var qty = parseInt(qtyVal ? qtyVal.textContent : '1') || 1;
      if (!vid) return;
      buyBtn.textContent = 'One moment...';
      buyBtn.disabled = true;
      fetch('/cart/add.js', {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:parseInt(vid),quantity:qty})})
        .then(function() { window.location.href = '/checkout'; })
        .catch(function() { buyBtn.innerHTML = '⚡ Buy Now — Shop Pay'; buyBtn.disabled = false; });
    });
  }

  /* Filter tabs */
  document.querySelectorAll('.filter-tab').forEach(function(tab) {
    tab.addEventListener('click', function() {
      document.querySelectorAll('.filter-tab').forEach(function(t) { t.classList.remove('active'); });
      this.classList.add('active');
    });
  });

  /* Email form */
  document.querySelectorAll('.email-form').forEach(function(form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var input = this.querySelector('input[type="email"]');
      var btn = this.querySelector('button[type="submit"]');
      if (input && btn) { btn.textContent = '\u2713 You\'re in!'; btn.disabled = true; input.value = ''; }
    });
  });

  /* Proof bar */
  var pt = document.querySelector('.proof-bar-track');
  if (pt) { var pi = pt.querySelector('.proof-bar-inner'); if (pi) pt.appendChild(pi.cloneNode(true)); }

  /* Sticky ATC */
  var sa = document.getElementById('stickyAtc');
  var am = document.getElementById('atc-main-btn');
  if (sa && am) {
    new IntersectionObserver(function(entries) {
      entries.forEach(function(e) { sa.classList.toggle('visible', !e.isIntersecting); });
    }, {threshold:0}).observe(am);
  }

  /* Pixel Union blocker */
  (function() {
    var _f = window.fetch;
    window.fetch = function(u, o) {
      if (typeof u === 'string' && (u.indexOf('pixelunion') !== -1 || u.indexOf('pxu-') !== -1))
        return Promise.resolve(new Response(JSON.stringify([]), {status:200,headers:{'Content-Type':'application/json'}}));
      return _f.apply(this, arguments);
    };
  })();

});
